/** Shared queries used across screens. */
import { useQuery } from '@tanstack/react-query';
import { api } from './api';

export interface PublicSettings { lguName: string; lguShortName: string; province: string; hotline: string; smsKeyword: string; privacyVersion: string }
export interface Barangay { id: string; name: string; code: string | null; active: boolean }
export interface CategoryRow { id: string; code: string; name: string; nameFil: string | null; parentId: string | null; active: boolean; sortOrder: number }

export const usePublicSettings = () => useQuery({ queryKey: ['settings', 'public'], queryFn: () => api<PublicSettings>('/settings/public', { anonymous: true }), staleTime: 10 * 60_000 });
export const useBarangays = () => useQuery({ queryKey: ['barangays'], queryFn: () => api<{ data: Barangay[] }>('/barangays').then((r) => r.data), staleTime: 10 * 60_000 });
/** Flat list of categories (top level and subcategories); the API returns a tree. */
export const useCategories = () => useQuery({
  queryKey: ['categories', 'flat'],
  queryFn: () => api<(CategoryRow & { children: CategoryRow[] })[]>('/categories').then((tree) => tree.flatMap(({ children, ...top }) => [top, ...children])),
  staleTime: 5 * 60_000,
});
